import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=c7bfe2ea&scoped=true&"
import script from "./folder.vue?vue&type=script&lang=js&"
export * from "./folder.vue?vue&type=script&lang=js&"
import style0 from "./folder.vue?vue&type=style&index=0&id=c7bfe2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bfe2ea",
  null
  
)

export default component.exports